import { Link } from "react-router-dom";
import styles from "./Logo.module.css";

function Logo() {
  return (
    <>
      <Link to="/">
        <img
          src={process.env.PUBLIC_URL + "/assets/img/logo-dark.png"}
          alt="akanbijrlogo.png"
          className={styles.img}
        />
      </Link>
    </>
  );
}

export default Logo;
